import React from 'react';
import MilaFilters from 'assets/images/mila-filters.png';
import MilaFiltersWebp from 'assets/images/mila-filters.png?as=webp';
import LazyLoad from 'react-lazyload';
import loadable from '@loadable/component';

const FadeIn = loadable(() => import('../common/FadeIn'));

const MissionDetail = ({ innerRef }) => (
  <section id='mission-detail' className='image-content' ref={innerRef}>
    <div className='container'>
      <div className='image-content__grid'>
        <div className='image-content__column'>
          <figure className='image-content__media'>
            <LazyLoad>
              <FadeIn>
                <picture>
                  <source srcSet={MilaFiltersWebp} type='image/webp' />
                  <source srcSet={MilaFilters} type='image/png' />
                  <img src={MilaFilters} alt='black and white mila version' />
                </picture>
              </FadeIn>
            </LazyLoad>
          </figure>
        </div>
        <div className='image-content__column'>
          <div className='image-content__content'>
            <h2 className='image-content__title'>
              Our mission is
              {' '}
              <strong>clear</strong>
              .
            </h2>
            <div className='image-content__description'>
              <p>
                While people examine the labels on everything they eat, they don’t know a thing about the
                air they breathe. We’re here to change that with thoughtful, insightful air-pliances
                that help bring cleaner, healthier air to every home. If you don’t need any convincing
                on why
                this mission matters...great. You’re one of us already.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default MissionDetail;
